import { IServiceFactory } from '../../common/types/service-factory';
import { IGrowthModelApiService, GrowthModelApiService } from '../services/growth-model-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class GrowthModelApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IGrowthModelApiService> {
	public Create(): IGrowthModelApiService {
		return new GrowthModelApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
